// vendorTenderThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchVendorTenders = createAsyncThunk(
    "vendorTender/fetchVendorTenders",
    async (filter = 'available', thunkAPI) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders`,
                { params: { filter } }
            );
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data tender"
            );
        }
    }
);

export const fetchTenderCounts = createAsyncThunk(
    "vendorTender/fetchTenderCounts",
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders_counts`
            );
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil jumlah tender"
            );
        }
    }
);

export const fetchTenderDetail = createAsyncThunk(
    "vendorTender/fetchTenderDetail",
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders/${id}`
            );
            return response.data.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data tender"
            );
        }
    }
);

// NEW: Register Tender
export const registerTender = createAsyncThunk(
    "vendorTender/registerTender",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders/register`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Gagal mendaftar tender"
            );
        }
    }
);

// NEW: Update registration status (opsional)
export const updateRegistrationStatus = createAsyncThunk(
    "vendorTender/updateRegistrationStatus",
    async ({ registrationId, status }, { rejectWithValue }) => {
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders/registration/${registrationId}`,
                { status }
            );
            return response.data.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Gagal update status registrasi"
            );
        }
    }
);

// NEW: Check registration status for a tender
export const checkRegistrationStatus = createAsyncThunk(
    "vendorTender/checkRegistrationStatus",
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders/${tenderId}/registration-status`
            );
            return response.data.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Gagal mengecek status registrasi"
            );
        }
    }
);

export const fetchKpiData = createAsyncThunk(
    "vendorTender/fetchKpiData",
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders_kpi`
            );
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data KPI"
            );
        }
    }
);


export const fetchActionItems = createAsyncThunk(
    "vendorTender/fetchActionItems",
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/tenders_action_items`
            );
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data action items"
            );
        }
    }
);